import { triggerBlobDownload } from '@/shared/lib/download/triggerBlobDownload';

export default async function downloadPDF(url: string, filename: string) {
  try {
    const response = await fetch(url);
    if (response.headers.get('content-type') !== 'application/pdf') {
      throw TypeError('Code not found.');
    }
    const blob = await response.blob();
    triggerBlobDownload(blob, filename);
  } catch (error) {
    console.error('Error downloading PDF:', error);
  }
}
